import Datetime from "react-datetime";
import { useTranslation } from "react-i18next";

import "../../styles/styles.scss";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";

import { validatePhoneNumber } from "../../../common/helper";
import moment from "moment";

const DOCOnlinePersonalInformation = ({
  docOnline,
  setDocOnline,
  errors,
  setErrors,
  jobRoles,
  maritalStatus,
  zones
}) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const onChangePersonalInformation = ({ target }) => {
    let personalInformationCache = { ...docOnline.personalInformation };

    if (target.value) {
      personalInformationCache[target.name] = target.value;
    } else {
      personalInformationCache[target.name] = null;
    }
    setDocOnline({
      ...docOnline,
      personalInformation: personalInformationCache
    });
  };

  function onChangeBirthDate(date) {
    let personalInformationCache = { ...docOnline.personalInformation };
    //let stringDate = date.toString();
    if (date.toString().includes("/") || date.toString().includes(".")) {
      setErrors({
        ...errors,
        birthDate: t("Date Format Invalid (DD-MM-YYYY)")
      });
      return;
    }

    if (date._d) {
      let isValid = validateDateOfBirth(date);
      setErrors({ ...errors, birthDate: null });
      if (!isValid) {
        setErrors({ ...errors, birthDate: t("The BirthDate is not allowed.") });
        return;
      }
    }
    personalInformationCache["birthDate"] = date._d;
    setDocOnline({
      ...docOnline,
      personalInformation: personalInformationCache
    });
  }

  function validateDateOfBirth(currentDate) {
    let isValid = true;
    let date = new Date();
    const MAX_AGE = 70;
    const MIN_AGE = 17;
    const YEARS = currentDate._d.getFullYear();
    const CURENTYEAR = date.getFullYear();
    if (
      currentDate >= date ||
      YEARS + MAX_AGE < CURENTYEAR ||
      YEARS + MIN_AGE > CURENTYEAR
    )
      isValid = false;
    return isValid;
  }

  function getDateValueValid() {
    if (docOnline.personalInformation.birthDate){
      if(docOnline.personalInformation.birthDate === "0001-01-01T00:00:00"){
        return null;
      }else{
        return new Date(docOnline.personalInformation.birthDate).toLocaleDateString("pt-PT");
      }
    }
      //return moment(new Date(docOnline.personalInformation.birthDate)).format("DD-MM-YYYY");
  }

  const onChangeAddressZone = ({ target }) => {
    let _personalInformation = { ...docOnline.personalInformation };

    if (target.value) {
      _personalInformation[target.name] = Number(target.value);
    } else {
      _personalInformation[target.name] = null;
    }

    setDocOnline({
      ...docOnline,
      personalInformation: _personalInformation
    });
  };

  const yearsOfExperienceIsValid = (value) => {
    if (value) {
      let yearsOfExperience = parseInt(value);
      if (isNaN(yearsOfExperience) === false) {
        if (yearsOfExperience >= 0 && yearsOfExperience <= 50) {
          return true;
        }
      }
    }
    return false;
  };

  const onChangeYearsOfExperience = ({ target }) => {
    let _personalInformation = { ...docOnline.personalInformation };

    if (yearsOfExperienceIsValid(target.value))
      setErrors({ ...errors, yearsOfExperience: null });
    else setErrors({ ...errors, yearsOfExperience: t("Invalid value.") });

    _personalInformation["yearsOfExperience"] = target.value;

    setDocOnline({
      ...docOnline,
      personalInformation: _personalInformation
    });
  };

  const onChangeMaritalStatus = ({ target }) => {
    let _personalInformation = { ...docOnline.personalInformation };

    if (target.value) {
      _personalInformation[target.name] = Number(target.value);
    } else {
      _personalInformation[target.name] = null;
    }

    setDocOnline({
      ...docOnline,
      personalInformation: _personalInformation
    });
  };

  const onChangePhoneNumber = ({ target }) => {
    const errorPhoneNumber = validatePhoneNumber(target.value, 18);

    if (errorPhoneNumber.format) {
      setErrors({
        ...errors,
        mobilePhoneNumber: t("Format is invalid.")
      });
    } else if (errorPhoneNumber.maxLength) {
      setErrors({
        ...errors,
        mobilePhoneNumber:
          t("The maximum number of characters is") +
          " " +
          errorPhoneNumber.maxNum
      });
    } else {
      setErrors({ ...errors, mobilePhoneNumber: null });
    }

    let _personalInformation = { ...docOnline.personalInformation };

    if (target.value) {
      _personalInformation[target.name] = target.value;
    } else {
      _personalInformation[target.name] = null;
    }

    setDocOnline({
      ...docOnline,
      personalInformation: _personalInformation
    });
  };

  return (
    <section className="step">
      <h2 className="title-style">{t("Personal Information")}</h2>
      <div className="doc-subtitle subtitle-style">
        {t("Enter the candidate's personal information.")}
      </div>
      <div className="card inboard p-4">
        <div className="doc-personal-info">
          <div className="form-group name" style={{width:"300px"}}>
            <div className="label-wrapper">
              <label htmlFor="consentFullName">
                {t("Full Name")}
                <label className="star-style">*</label>
              </label>
              {errors !== undefined && errors.fullName && (
                <span className="error-msg">{errors.fullName}</span>
              )}
            </div>
            <input
              id="fullName"
              name="fullName"
              type="text"
              onChange={onChangePersonalInformation}
              placeholder={t("Name")}
              maxLength={100}
              value={docOnline.personalInformation.fullName}
            />
          </div>
          <div className="form-group birth-date" style={{width:"150px"}}>
            <div className="label-wrapper">
              <label htmlFor="consentDateOfBirth">
                {t("Date of birth")}
                <label className="star-style">*</label>
              </label>
              {errors !== undefined && errors.birthDate && (
                <span className="error-msg">{errors.birthDate}</span>
              )}
            </div>
            <Datetime
              inputProps={{
                id: "birthDate",
                placeholder: t("dd-mm-yyyy")
              }}
              name="birthDate"
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              onChange={onChangeBirthDate}
              isValidDate={validateDateOfBirth}
              closeOnSelect={true}
              utc={true}
              value={getDateValueValid()}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
            />
          </div>

          <div className="form-group zone size-field" style={{width:"285px"}}>
            <div className="label-wrapper">
              <label>{t("Zone")}</label>
            </div>
            <select
              id="addressZoneId"
              name="addressZoneId"
              className="form-select"
              onChange={onChangeAddressZone}
              value={docOnline.personalInformation.addressZoneId || ""}
            >
              <option key={0} value="" selected disabled>
                {t("Add a Zone")}
              </option>
              {zones &&
                zones.map((item) => (
                  <option key={item.id} value={item.id}>
                    {t(item.description)}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group marital-status" style={{width:"140px"}}>
            <div className="label-wrapper">
              <label>
                {t("Marital Status")}
              </label>
            </div>
            <select
              id="maritalStatusId"
              name="maritalStatusId"
              className="form-select"
              onChange={onChangeMaritalStatus}
              value={docOnline.personalInformation.maritalStatusId || null}
            >
              <option key={0} value="" selected disabled>
                {t("Select an option...")}
              </option>
              {maritalStatus &&
                maritalStatus.map((item) => (
                  <option key={item.id} value={item.id}>
                    {t(item.description)}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group phoneNumber" style={{width:"145px", marginLeft:"-10px"}}>
            <div className="label-wrapper">
              <label>{t("Mobile Number")}</label>
              {errors.mobilePhoneNumber && (
                <div className="error-msg">{errors.mobilePhoneNumber}</div>
              )}
            </div>
            <input
              id="mobilePhoneNumber"
              name="mobilePhoneNumber"
              type="tel"
              onChange={onChangePhoneNumber}
              value={docOnline.personalInformation.mobilePhoneNumber}
            />
          </div>

          <div className="form-group years-exp" style={{width:"150px"}}>
            <div className="label-wrapper">
              <label>
                {t("Years of Experience")}
                <label className="star-style">*</label>
              </label>
              {errors.yearsOfExperience && (
                <div className="error-msg">{errors.yearsOfExperience}</div>
              )}
            </div>
            <input
              className="input-field"
              type="number"
              id="yearsOfExperience"
              name="yearsOfExperience"
              onChange={onChangeYearsOfExperience}
              value={docOnline.personalInformation.yearsOfExperience}
              maxLength={2}
            />
          </div>

          <div className="form-group role size-field" style={{width:"285px"}}>
            <div className="label-wrapper">
              <label>
                {t("Job Role")}
                <label className="star-style">*</label>
              </label>
              {errors !== undefined && errors.jobRoleId && (
                <span className="error-msg">{errors.jobRoleId}</span>
              )}
            </div>
            <select
              id="jobRoleId"
              name="jobRoleId"
              className="form-select"
              onChange={onChangePersonalInformation}
              value={docOnline.personalInformation.jobRoleId}
            >
              <option key={0} selected disabled value={0}>
                {t("Add a Role")}
              </option>
              {jobRoles &&
                jobRoles.map((item) => (
                  <option key={item.id} value={item.id}>
                    {t(item.description)}
                  </option>
                ))}
            </select>
          </div>
          <div className="form-group resume">
            <div className="label-wrapper">
              <label>
                {t("Presentation of the functions performed (Resume)")}
                <label className="star-style">*</label>
              </label>
              {errors.resume && (
                <div className="error-msg">{errors.resume}</div>
              )}
            </div>
            <textarea
              id="resume"
              rows="4"
              name="resume"
              onChange={onChangePersonalInformation}
              maxLength={500}
              value={docOnline.personalInformation.resume}
            />
          </div>

          <div className="form-group github-url">
            <div className="label-wrapper">
              <label htmlFor="consentGitHub">GitHub (URL)</label>
            </div>
            <input
              className="input-field"
              type="text"
              placeholder="https://github.com"
              id="gitHub"
              name="gitHub"
              onChange={onChangePersonalInformation}
              value={docOnline.personalInformation.gitHub}
              maxLength={250}
            />
          </div>
          <div className="form-group linkedin">
            <div className="label-wrapper">
              <label htmlFor="">Linkedin</label>
            </div>
            <input
              className="input-field"
              type="text"
              placeholder="https://linkedin.com"
              id="linkedinURL"
              name="linkedinURL"
              onChange={onChangePersonalInformation}
              value={docOnline.personalInformation.linkedinURL}
              maxLength={250}
            />
          </div>
          <div className="form-group hobbies">
            <div className="label-wrapper">
              <label htmlFor="consentHobbies">{t("Hobbies")}</label>
            </div>
            <textarea
              id="hobbies"
              rows="4"
              name="hobbies"
              placeholder={t("Describe your hobbies...")}
              onChange={onChangePersonalInformation}
              value={docOnline.personalInformation.hobbies}
              maxLength={250}
            />
          </div>
        </div>
      </div>
      <div style={{ color: "red" }}>
        <label className="star-style">*</label>{" "}
        <label style={{ marginLeft: "20px" }}>{t("Required field")}</label>
      </div>
    </section>
  );
};

export default DOCOnlinePersonalInformation;
